// extracted by mini-css-extract-plugin
export default {"bright":"KUWOdYZ4Lk42k3lvLUcM"};